// import { pollInstance } from '@/axios';
import Vue from 'vue';
import helper from './../../../shared/helper';
/* eslint-disable no-param-reassign */

const profileModule = {
	actions: {
		async loadJobProfileConfig({ commit, state }) {
			// Evitar cargar si ya está cargado (cache)
			if (state.mainData &&
				typeof state.mainData === 'object' &&
				state.mainData.config &&
				state.mainData.config.stages &&
				Array.isArray(state.mainData.config.stages) &&
				state.mainData.config.stages.length > 0) {
				return state.mainData;
			}

			const JOB_PROFILE_TOOL_CODE = 'JPF';
			const { data } = await Vue.prototype.$http.get(`/tools/${JOB_PROFILE_TOOL_CODE}`);
			commit('UPDATE_MAIN_DATA', data);
			return data;
		},
		async loadKnowledges({ commit, state }) {
			// Evitar cargar si ya están cargados (cache)
			if (state.descriptionData.knowledge &&
				typeof state.descriptionData.knowledge === 'object' &&
				state.descriptionData.knowledge.data &&
				Array.isArray(state.descriptionData.knowledge.data) &&
				state.descriptionData.knowledge.data.length > 0) {
				return state.descriptionData.knowledge;
			}

			const { data } = await Vue.prototype.$httpPraktiko.get('/general-data/KNW');
			const payload = {
				name: 'Conocimientos',
				data,
			};
			commit('UPDATE_LEVEL_SELECTION_KNOWLEDGE', payload);
			return payload;
		},
		async loadCareers({ commit, state }) {
			// Evitar cargar si ya están cargados (cache)
			if (state.descriptionData.careers &&
				Array.isArray(state.descriptionData.careers) &&
				state.descriptionData.careers.length > 0) {
				return state.descriptionData.careers;
			}
			const { data } = await Vue.prototype.$httpPraktiko.get('/general-data/CAR');
			commit('UPDATE_LEVEL_SELECTION_CAREER', data);
			return data;
		},
		async loadTimes({ commit, state }) {
			// Evitar cargar si ya están cargados (cache)
			if (state.descriptionData.times &&
				typeof state.descriptionData.times === 'object' &&
				state.descriptionData.times.data &&
				Array.isArray(state.descriptionData.times.data) &&
				state.descriptionData.times.data.length > 0) {
				return state.descriptionData.times;
			}

			const { data } = await Vue.prototype.$httpPraktiko.get('/general-data/TMP');
			commit('UPDATE_LEVEL_SELECTION_TIME', data);
			return data;
		},
		async loadMeasureOfTime({ commit, state }) {
			// Evitar cargar si ya están cargados (cache)
			if (state.descriptionData.measureOfTime &&
				Array.isArray(state.descriptionData.measureOfTime) &&
				state.descriptionData.measureOfTime.length > 0) {
				return state.descriptionData.measureOfTime;
			}

			const { data } = await Vue.prototype.$httpPraktiko.get('/general-data/MTP');
			commit('UPDATE_LEVEL_SELECTION_MEASURE_TIME', data);
			return data;
		},
		async loadResponsabilities({ commit, state }) {
			// Evitar cargar si ya están cargados (cache)
			if (state.descriptionData.responsabilities &&
				Array.isArray(state.descriptionData.responsabilities) &&
				state.descriptionData.responsabilities.length > 0) {
				return state.descriptionData.responsabilities;
			}

			const { data } = await Vue.prototype.$httpPraktiko.get('/general-data/RSTY');
			commit('UPDATE_LEVEL_SELECTION_RESPONSABILITIES', data);
			return data;
		},
		async loadRelevance({ commit, state }) {
			// Evitar cargar si ya están cargados (cache)
			if (state.descriptionData.relevance &&
				Array.isArray(state.descriptionData.relevance) &&
				state.descriptionData.relevance.length > 0) {
				return state.descriptionData.relevance;
			}

			const { data } = await Vue.prototype.$httpPraktiko.get('/general-data/RLVC');
			commit('UPDATE_LEVEL_SELECTION_RELEVANCE', data);
			return data;
		},
		async loadSortJobList({ commit }) {
			const params = {
				sortField: 'name',
				sortDirection: 'ASC',
			};
			const { data } = await Vue.prototype.$httpPraktiko.get('groups/jobs', { params });
			commit('LOAD_SORT_JOBLIST', data);
		},
		// ✅ NUEVO: Acción para cargar job description con cache
		async loadJobDescription({ commit, state }, { codeStep, jobId, forceRefresh = false }) {
			const cacheKey = `${codeStep}_${jobId}`;

			// ✅ CACHE INTELIGENTE: Verificar si el cache existe y no ha expirado
			const CACHE_DURATION = 15 * 60 * 1000; // 15 minutos
			const cacheEntry = state.jobDescriptionCache[cacheKey];
			const now = Date.now();
			const isCacheValid = cacheEntry && (now - cacheEntry.timestamp) < CACHE_DURATION;

			// Evitar cargar si cache es válido y no se fuerza refresh
			if (!forceRefresh && isCacheValid) {
				return cacheEntry.data;
			}

			try {
				const { data } = await Vue.prototype.$httpPraktiko.get(`job-description/detail/${codeStep}/${jobId}`);

				// Guardar en cache
				commit('SET_JOB_DESCRIPTION_CACHE', { cacheKey, data });

				return data;
			} catch (error) {
				throw error;
			}
		},

		// ✅ NUEVO: Acción para limpiar cache de job descriptions
		clearJobDescriptionCache({ commit }, jobId = null) {
			commit('CLEAR_JOB_DESCRIPTION_CACHE', jobId);
		},

		// ✅ NUEVO: Limpiar todos los caches (para casos extremos)
		clearAllCaches({ commit }) {
			commit('CLEAR_JOB_DESCRIPTION_CACHE', null); // Limpiar cache de descriptions
			commit('UPDATE_MAIN_DATA', {}); // Limpiar cache de config
			// Limpiar otros caches si es necesario
		},


		// ✅ NUEVO: Acción para invalidar cache después de guardar
		async saveJobDescriptionAndInvalidateCache({ dispatch }, { url, body, jobId, successMessage }) {
			try {
				// Guardar en servidor
				await Vue.prototype.$httpPraktiko.post(url, body);

				// Invalidar cache del job específico
				dispatch('clearJobDescriptionCache', jobId);

				return { success: true, message: successMessage };
			} catch (error) {
				throw error;
			}
		},

		saveJobSelected({ commit }, selectedJob) {
			helper.setLocalData('selectedJob', selectedJob);
			commit('SAVE_JOB_SELECTED', selectedJob);
		},
	},
	state: {
		selectedJob: {},
		mainData: {},
		descriptionData: {
			knowledge: null, // Cambiar de {} a null para mejor detección de cache
			careers: null, // Cambiar de {} a null para mejor detección de cache
			times: null, // Cambiar de {} a null para mejor detección de cache
			measureOfTime: null, // Cambiar de {} a null para mejor detección de cache
			responsabilities: null, // Cambiar de {} a null para mejor detección de cache
			relevance: null, // Cambiar de {} a null para mejor detección de cache
		},
		// ✅ NUEVO: Cache para job descriptions por código y jobId
		jobDescriptionCache: {},
		jobList: [],
	},
	mutations: {
		SAVE_JOB_SELECTED(state, selectedJob) {
			state.selectedJob = selectedJob;
		},
		UPDATE_LEVEL_SELECTION_KNOWLEDGE(state, payload) {
			state.descriptionData.knowledge = payload;
		},
		UPDATE_LEVEL_SELECTION_CAREER(state, payload) {
			state.descriptionData.careers = payload;
		},
		UPDATE_LEVEL_SELECTION_TIME(state, payload) {
			state.descriptionData.times = payload;
		},
		UPDATE_LEVEL_SELECTION_MEASURE_TIME(state, payload) {
			state.descriptionData.measureOfTime = payload;
		},
		UPDATE_LEVEL_SELECTION_RESPONSABILITIES(state, payload) {
			state.descriptionData.responsabilities = payload;
		},
		UPDATE_LEVEL_SELECTION_RELEVANCE(state, payload) {
			state.descriptionData.relevance = payload;
		},
		LOAD_SORT_JOBLIST(state, payload) {
			state.jobList = payload;
		},
		UPDATE_MAIN_DATA(state, data) {
			state.mainData = data;
		},
		// ✅ NUEVO: Mutaciones para cache de job descriptions
		SET_JOB_DESCRIPTION_CACHE(state, { cacheKey, data }) {
			state.jobDescriptionCache[cacheKey] = {
				data,
				timestamp: Date.now(),
			};
		},
		CLEAR_JOB_DESCRIPTION_CACHE(state, jobId = null) {
			if (jobId) {
				// Limpiar cache específico de un job
				Object.keys(state.jobDescriptionCache).forEach((key) => {
					if (key.includes(`_${jobId}`)) {
						delete state.jobDescriptionCache[key];
					}
				});
			} else {
				// Limpiar todo el cache
				state.jobDescriptionCache = {};
			}
		},
	},
};

export default profileModule;



// WEBPACK FOOTER //
// ./src/modules/job-profile/store/index.js